import React, {useMemo} from "react"
import {useTheme} from "@mui/material"
import StackedDonutBase from "./Charts/stacked-donut-base"
import {numberToDeNumberString} from "../../misc/utils"

export const widgetZielscheibePrototype = [
    {
        key: "maxHeight",
        type: "STRING",
        label: "Maximale Höhe",
        size: 3,
    },
]

const SHORT_HEX_LENGTH = 3
const RADIX = 16

function convertHexToRGBA(hexCode, opacity = 1) {
    let hex = hexCode.replace("#", "")
    if (!/^[0-9a-fA-F]{3}$|^[0-9a-fA-F]{6}$/.test(hex)) {
        return "rgba(0,0,0,1)"
    }
    if (hex.length === SHORT_HEX_LENGTH) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
    }
    const r = Number.parseInt(hex.substring(0, 2), RADIX)
    const g = Number.parseInt(hex.substring(2, 4), RADIX)
    const b = Number.parseInt(hex.substring(4, 6), RADIX)
    const alpha = Math.min(1, Math.max(0, opacity))
    return `rgba(${r},${g},${b},${alpha})`
}

const ZielscheibeWidget = ({widget, value}) => {
    const theme = useTheme()
    const {ring1, ring2, ring3, trackOpacity} = theme.ZIELSCHEIBE

    const defaultData = useMemo(() => [
        {hex: ring1 ?? "#B3261E", valPrimary: 1, valSecondary: 2, label: "Altersvorsorge"},
        {hex: ring2 ?? "#072ECA", valPrimary: 2, valSecondary: 3, label: "Einkommensschutz"},
        {hex: ring3 ?? "#66A61E", valPrimary: 4, valSecondary: 5, label: "Hinterbliebenenschutz"},
    ], [ring1, ring2, ring3])

    const entries = value && Array.isArray(value) ? value : defaultData

    const datasets = entries.map(({valPrimary, valSecondary, hex, label}) => ({
        label,
        segmentLabels: ["Ist", "Lücke"],
        data: [valPrimary, valSecondary],
        backgroundColor: [hex, convertHexToRGBA(hex, trackOpacity)],
        formattedValue: [`${numberToDeNumberString(valPrimary)} €`, `${numberToDeNumberString(valSecondary)} €`],
    }))

    return <StackedDonutBase datasets={datasets} height={Number.parseInt(widget?.maxHeight)} />
}

export default ZielscheibeWidget
